import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('relatorio', 'pendencias');

const relatorioActions = {
  acaoAgAnalise: { method: 'GET', url: `${basePath}/acao-ag-analise` },
  acaoAgAprovacao: { method: 'GET', url: `${basePath}/acao-ag-aprovacao` },
  orcamentoAgAprovacao: { method: 'GET', url: `${basePath}/orcamento-ag-aprovacao` },
  pagamentoAgAprovacao: { method: 'GET', url: `${basePath}/pagamento-ag-aprovacao` },
  acaoAgOrcamento: { method: 'GET', url: `${basePath}/acao-ag-orcamento` },
  orcamentoAgAnalise: { method: 'GET', url: `${basePath}/orcamento-ag-analise` },
  pagamentoAgAnalise: { method: 'GET', url: `${basePath}/pagamento-ag-analise` },
};

export default resource => resource(`${basePath}`, {}, relatorioActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/relatorio/pendencias.js